import { NgxLoggerLevel } from 'ngx-logger';
import { AppEnvironment, commonEnvironment } from './environment.common';
import { EnvName } from 'envName';

const clientId = '7q9tr4a9nh882iaqju6t3om6sm'; //Cognito
const redirectUrl = 'https://demo.mybenefits-int.symetra.com/demologin';
const loginOrigin = 'https://demo.mybenefits-int.symetra.com/login';
const appBaseUrl = 'https://demo.mybenefits-int.symetra.com';
const profileSettingsUrl = 'https://profile.account-int.symetra.com/';
const partnerPortalUrl = 'https://login.partnerportal.dcx.int.symetra.com';
const claimDetailPolicyHolderCTAUrl = 'https://symetralams--demo.sandbox.my.site.com/portal';
const documentDownloadLink = 'https://bdportal-mocks.bdportal-int.symetra.cloud';
const quicksightLifeStatusDashboardId = 'life-status-dashboard-id-demo'; // todo
const quicksightWopStatusDashboardId = 'wop-status-dashboard-id-demo'; // todo

export const environment: AppEnvironment = {
  ...commonEnvironment,
  environmentName: EnvName.DEMO,
  icapEnabled: false,
  pageTitleSuffix: 'My Benefits at Symetra (DEMO)',
  clientId,
  loginUrl: redirectUrl,
  redirectUrl,
  profileSettingsUrl,
  partnerPortalUrl,
  loginOrigin,
  appBaseUrl,
  claimDetailPolicyHolderCTAUrl,

  serverTelemetryLevel: NgxLoggerLevel.DEBUG,
  quicksight: {
    lifeStatusDashboardId: quicksightLifeStatusDashboardId,
    wopStatusDashboardId: quicksightWopStatusDashboardId
  },
  documentDownloadLink
};
